import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { II18nMessages } from '../../services/branding/models';
import { Redirect, Route, Switch } from 'react-router';
import Login from './scenes/Login';
import AccountSummary from './scenes/AccountSummary';
import PolicyDetail from './scenes/PolicyDetail';
import ForgottenPassword from './scenes/ForgottenPassword';
import ResetPassword from './scenes/ResetPassword';
import CreateAnAccount from './scenes/CreateAnAccount';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow } from 'lodash';
import { actions as authActions} from '../../services/auth/reducer';
import { IAuthActions, IAuthState } from '../../services/auth/models';
import SetPassword from './scenes/SetPassword';

interface ICustomerAreaProps {
  i18n: II18nMessages;
  auth: IAuthState;
  actions: {
    auth: IAuthActions;
    push(route: string);
  };
}

class CustomerArea extends React.Component<ICustomerAreaProps> {
  public componentWillMount() {
    if (process.env.BROWSER) {
      window.scrollTo(0, 0);
    }
  }

  private renderAuthenticatedRoutes = () => {
    return (
      <Switch>
        <Redirect from="/auth" to="/account/summary" />
        <Route exact={true} path="/account/summary" component={AccountSummary} />
        <Route exact={true} path="/account/policies/:id" component={PolicyDetail} />
        <Route exact={true} path="/account/quotes/:id" component={PolicyDetail} />
        <Route exact={true} path="/account/renewals/:id" component={PolicyDetail} />
      </Switch>
    );
  }

  private renderUnauthenticatedRoutes = () => {
    return (
      <Switch>
        <Redirect from="/account" to="/auth/login" />
        <Route exact={true} path="/auth/login" component={Login} />
        <Route exact={true} path="/auth/remind" component={ForgottenPassword} />
        <Route exact={true} path="/auth/create-an-account" component={CreateAnAccount} />
        <Route exact={true} path="/password/reset/:token" component={ResetPassword} />
        <Route exact={true} path="/password/set/:token" component={SetPassword} />
      </Switch>
    );
  }

  public render() {
    const { auth } = this.props;

    return (
      <div className="internal-page">
        <div className="container">
          <Row>
            <Col md={12}>
              <div className="customer-area-container">
                <div className="customer-area-container__title">Customer Area</div>
                <div className="max-width-wrapper">
                  {auth.isAuthenticated ? this.renderAuthenticatedRoutes() : this.renderUnauthenticatedRoutes()}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default flow([
  connect(
    (state) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        auth: bindActionCreators({...authActions}, dispatch),
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(CustomerArea);
